import { isEmpty } from 'lodash';

const checkIsResetAllFilter = (filter) => {
  return (
    !isEmpty(filter?.brand) ||
    !isEmpty(filter?.account) ||
    !isEmpty(filter?.platform) ||
    !isEmpty(filter?.host) ||
    !isEmpty(filter?.studio) ||
    !isEmpty(filter?.operator)
  );
};

export default checkIsResetAllFilter;
